import { render, staticRenderFns } from "./ChecklistActivityFormChildEmbeddable.vue?vue&type=template&id=1b57dc8c&"
import script from "./ChecklistActivityFormChildEmbeddable.vue?vue&type=script&lang=js&"
export * from "./ChecklistActivityFormChildEmbeddable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports